<div class="description-modal" [ngClass]="{ back: state.length > 1 }" [class.state]="state.length > 1" *ngIf="isModalVisible">
  <span *ngIf="state.length > 1" class="fa fa-arrow-left btn-back" aria-hidden="true" (click)="back()"></span>

  <app-description-consumer
    class="app-description-consumer"
    *ngIf="getLast(state) === 'consumer' && !IsEditBuilding"
    [data]="data"
    (saveEmitter)="save($event)"
    (closeEmitter)="descriptionConsumerClose($event)"
    (efficiencyAnalysisDisplayEmitter)="openEfficiencyWizard()"
    (isFromDescriptionConsumer)="isFromDescriptionConsumer = true"
  ></app-description-consumer>

  <app-description-object-type
    class="app-description-object-type"
    *ngIf="IsEditBuilding"
    [data]="data"
    [editType]="editType"
    (saveEmitter)="save($event)"
    (efficiencyAnalysisDisplayEmitter)="isBenchmarkVisible = false; isModalVisible = false"
  >
  </app-description-object-type>

  <app-description-producer
    class="app-description-producer"
    *ngIf="getLast(state) === 'producer'"
    (questionnaireDisplayEmitter)="isQuestionnaireVisible = true; isModalVisible = false"
    [data]="data"
    (saveEmitter)="save($event)"
  ></app-description-producer>

  <app-description-main
    class="app-description-main"
    *ngIf="getLast(state) === 'asset-list'"
    [consumers]="consumers"
    [producers]="producers"
    [plantTypes]="plantTypes"
    (assetSelectEmitter)="selectAsset($event)"
    (plantTypeSelectEmitter)="selectPlantType($event)"
  ></app-description-main>

  <app-description-producer-list
    class="app-description-producer-list"
    *ngIf="getLast(state) === 'producer-list'"
    [consumer]="consumers.length > 0 ? consumers[0] : null"
    [producers]="filteredProducers"
    (assetSelectEmitter)="selectAsset($event)"
  ></app-description-producer-list>

  <app-description-sensor
    *ngIf="sensors.length > 0"
    [sensors]="sensors"
    class="app-description-sensor"
    (navigatedOut)="isModalVisible = false; hideVisibility()"
  >
  </app-description-sensor>

  <button type="button" class="close-modal" (click)="hideVisibility()"></button>
</div>

<div *ngIf="isEfficiencyAnalysisOpen" [class.overlay]="isModalVisible">
  <app-building-efficiency-wizard
    [buildingZipcode]="data.zipCode"
    [buildingGuid]="data.guid"
    [visibility]="isEfficiencyAnalysisOpen"
    (closeEvent)="closeEfficiencyAnalysisWizard($event)"
    (saveEmitter)="saveNewEfficiencyAnalysis($event)"
  >
  </app-building-efficiency-wizard>
</div>

<app-performance-questionnaire
  *ngIf="isQuestionnaireVisible"
  [alignment]="data.orientation"
  [tiltAngle]="data.inclination"
  [visibility]="isQuestionnaireVisible"
  (closeEvent)="onQuestionnaireClose($event)"
>
</app-performance-questionnaire>
